import { call } from 'redux-saga/effects';
import { whiteboardClosed } from 'features/layout/features/content/actions';
import { SignalingSocket } from 'services/signaling';

export function* closeWhiteboardSaga(action: ReturnType<typeof whiteboardClosed>) {
  yield call(SignalingSocket.send, { event: 'closeWhiteboard', data: { id: action.payload } });
}
